import { Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useRecoilState } from 'recoil';
import { showSensitiveInfoState } from '~/state/atoms/viewerAtoms';

interface SensitiveInfoTypographyProps {
    children: ReactNode;
    sx?: object;
}

const SensitiveInfoTypography = ({
    children,
    sx,
}: SensitiveInfoTypographyProps) => {
    const [showSensitiveInfo] = useRecoilState(showSensitiveInfoState);
    const isSensitive = showSensitiveInfo ? 'false' : 'true';
    return (
        <Typography
            component="span"
            sx={{
                filter: showSensitiveInfo ? 'none' : 'blur(0.5rem)',
                ...sx,
            }}
            data-testid="sensitive-info-typography"
            data-sensitive={isSensitive}
        >
            {children}
        </Typography>
    );
};

export default SensitiveInfoTypography;
